import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedDateTime, FormattedMessage, FormattedReactMessage } from '../../../components/I18n';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import RetakeExamButton from './RetakeExamButton';
import { useFullTrack } from '../../tracks';
import { useExamExpiry, useMostRecentExamAttempt } from '../../exams';

/* This scenario can occur when a user completes the exam _without_ first completing
 * the graded practical exercises. Then after the attempt expires after a year, they
 * complete the practical exercises, but are unable to receive a certificate as
 * it's been more than a year since the last exam attempt.
 */
const ExamAttemptExpiredScreen = ({
  trackId
}) => {
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId));
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId);
  const {
    expiresOn,
    examExpiryLoading,
    examExpiryError
  } = useExamExpiry(Number(trackId));
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsx(RetakeExamButton, {
      trackId: trackId,
      use: "primary"
    }),
    error: mostRecentExamAttemptError || examExpiryError || trackError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.expiredAttempt"
    }),
    illustration: "announcement",
    loading: mostRecentExamAttemptLoading || examExpiryLoading || trackLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourPreviousScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.expiredAttemptSubheading",
      options: {
        expiryDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: expiresOn
        })
      }
    }),
    trackId: trackId
  });
};

export default ExamAttemptExpiredScreen;